<template>
  <el-drawer v-model="visible" :title="'角色 ('+roleData.name+') 人员管理'" custom-class="sys-role-drawer"  size="1000" destroy-on-close>
    <!-- 平台所有人员 -->
    <div class="role-user-main">
        <div class="search-main">
            <el-form :inline="true"  class="demo-form-inline">
                <el-form-item label="">
                    <div class="top-cen-tip">平台用户</div>
                </el-form-item>
                <el-form-item label="">
                    <el-input v-model="leftParams.name"  placeholder="用户名" clearable >
                    </el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-input v-model="leftParams.idCard"  placeholder="身份证号" clearable >
                    </el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-input v-model="leftParams.phone"  placeholder="电话号码" clearable >
                    </el-input>
                </el-form-item>
                <el-form-item style="margin-right:20px">
                <el-button type="primary"   :icon="Search" @click="getAllUserData">查询</el-button>
                </el-form-item  >
            </el-form>
        </div>
        <div class="table-main">
            <el-table
                :data="leftParams.data"
                style="width: 100%;"
                row-key="id"
                border
                height="calc(100% )"
                v-loading="loading"
                size="small"
                > 
                <el-table-column label="序号" width="55" type="index">
                </el-table-column>
                <el-table-column label="用户名">
                    <template #default="{row}">
                        {{row.name}}
                    </template>
                </el-table-column>
                <el-table-column label="身份证号">
                    <template #default="{row}">
                        {{row.idCardNo}}
                    </template>
                </el-table-column>
                <el-table-column label="电话号码">
                    <template #default="{row}">
                        {{row.phone}}
                    </template>
                </el-table-column>
                <el-table-column label="是否实名">
                    <template #default="{row}">
                        <el-tag v-if="row.isReal==1"> 是</el-tag>
                        <el-tag type="warning" v-else> 否</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="100" >
                <template #default="{row}">
                    <el-button type="text" size="small" @click="saveRoleUserClick(row)"  >添加</el-button>
                </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page-main">
            <el-pagination
            @size-change="handleSizeChangeleft"
            @current-change="handleCurrentChangeleft"
            :current-page="leftParams.currentPage"
            :page-sizes="[20, 50, 100, 500]"
            :page-size="leftParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="leftParams.pageTotal">
            </el-pagination>
        </div>
    </div>

    <!-- 已选人员 -->
    <div class="role-user-main" style="margin-top:2%;">
        <div class="search-main">
            <el-form :inline="true"  class="demo-form-inline">
                <el-form-item label="">
                    <div class="top-cen-tip">角色授权用户</div>
                </el-form-item>
                <el-form-item label="">
                    <el-input v-model="rightParams.name"  placeholder="用户名" clearable >
                    </el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-input v-model="rightParams.idCard"  placeholder="身份证号" clearable >
                    </el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-input v-model="rightParams.phone"  placeholder="电话号码" clearable >
                    </el-input>
                </el-form-item>
                <el-form-item style="margin-right:20px">
                <el-button type="primary" :icon="Search" @click="getRoleUserData">查询</el-button>
                </el-form-item  >
            </el-form>
        </div>
        <div class="table-main">
            <el-table
                :data="rightParams.data"
                style="width: 100%;"
                row-key="id"
                border
                height="calc(100% )"
                v-loading="loading2"
                size="small"
                > 
                <el-table-column label="序号" width="55" type="index">
                </el-table-column>
                <el-table-column label="用户名">
                    <template #default="{row}">
                        {{row.name}}
                    </template>
                </el-table-column>
                <el-table-column label="身份证号">
                    <template #default="{row}">
                        {{row.idCardNo}}
                    </template>
                </el-table-column>
                <el-table-column label="电话号码">
                    <template #default="{row}">
                        {{row.phone}}
                    </template>
                </el-table-column>
                <el-table-column label="是否实名">
                    <template #default="{row}">
                        <el-tag v-if="row.isReal==1"> 是</el-tag>
                        <el-tag type="warning" v-else> 否</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="100" >
                <template #default="{row}">
                    <el-button type="text" @click="delRoleUserClick(row)"  >移除</el-button>
                </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page-main">
            <el-pagination
            @size-change="handleSizeChangeright"
            @current-change="handleCurrentChangeright"
            :current-page="rightParams.currentPage"
            :page-sizes="[20, 50, 100, 500]"
            :page-size="rightParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="rightParams.pageTotal">
            </el-pagination>
        </div>
    </div>
    <template #footer>
      <div style="flex: auto">
        <el-button @click="visible = false">取消</el-button>
      </div>
    </template>
  </el-drawer>
</template>

<script>
import { ref,defineComponent } from 'vue'
import {getAllUserList, getRoleUserList ,saveRoleUser,delRoleUser} from '@/api/sys/role';
import {Search,CirclePlusFilled } from '@element-plus/icons-vue'
export default defineComponent({
  data() {
    return {
      Search,
      loading:false,
      loading2:false,
      visible: false,
      roleData: {
        id: null,
        name:'',
        isEffective:1,
      },
      leftParams:{
          name:'',
          idCard:'',
          phone:'',

          data:[],

          currentPage:1,//当前页
          pageSize:20,//每页条数
          pageTotal:0,//总条数
      },
      rightParams:{
          name:'',
          idCard:'',
          phone:'',
          
          data:[],

          currentPage:1,//当前页
          pageSize:20,//每页条数
          pageTotal:0,//总条数
      },
      
      

    }
  },
  methods: {
    //`每页 ${val} 条`
    handleSizeChangeleft(val) {
      this.leftParams.pageSize=val;
      this.getAllUserData();
    },
    //`当前页: ${val}`
    handleCurrentChangeleft(val) {
      this.leftParams.currentPage=val;
      this.getAllUserData();
    },
    //`每页 ${val} 条`
    handleSizeChangeright(val) {
      this.rightParams.pageSize=val;
      this.getRoleUserData();
    },
    //`当前页: ${val}`
    handleCurrentChangeright(val) {
      this.rightParams.currentPage=val;
      this.getRoleUserData();
    },
    show(row) {
      if(row){
        this.roleData=row;
        this.getAllUserData();
        this.getRoleUserData();
      }else{
        this.roleData={
          id: null,
          name:'',
          isEffective:1,
        };
      }
      this.visible = true;
      
    },
    
    //获取数据
    getAllUserData() {
      this.loading = true;
      let param={};
      param.id=this.roleData.id;
      param.name=this.leftParams.name;
      param.idCard=this.leftParams.idCard;
      param.phone=this.leftParams.phone;
      param.currentPage=this.leftParams.currentPage;
      param.pageSize=this.leftParams.pageSize;
      //所有人员
      getAllUserList(param).then(({data}) => {
        this.leftParams.data=data.data;
        if(data.page){
          this.leftParams.currentPage=data.page.pageNo;
          this.leftParams.pageTotal=data.page.totalRecords;
        }
        this.loading = false;
      }).catch(
          
      );
    },
    //获取角色人员数据
    getRoleUserData() {
      this.loading2 = true;
      let param={};
      param.id=this.roleData.id;
      param.name=this.rightParams.name;
      param.idCard=this.rightParams.idCard;
      param.phone=this.rightParams.phone;
      param.currentPage=this.rightParams.currentPage;
      param.pageSize=this.rightParams.pageSize;
      //所有人员
      getRoleUserList(param).then(({data}) => {
        this.rightParams.data=data.data;
        if(data.page){
          this.rightParams.currentPage=data.page.pageNo;
          this.rightParams.pageTotal=data.page.totalRecords;
        }
        this.loading2 = false;
      }).catch(
          
      );
    },
    saveRoleUserClick(row){
        let param={};
        param.roleId=this.roleData.id;
        let userIdArr=[];
        userIdArr.push(row.id);
        param.userIdArr=userIdArr;
        this.$confirm('确定添加人员 <'+row.name+'> ？', '提示').then(_ => {
            saveRoleUser(param).then(({data}) => {
                if (data.status) {
                    this.$message.success(data.msg);
                    this.getAllUserData();
                    this.getRoleUserData();
                } else {
                    this.$message.warning(data.msg);
                }
            }).catch(_ => {})
      }).catch(_ => {})
           
    },
    delRoleUserClick(row){
        let param={};
        param.roleId=this.roleData.id;
        let userIdArr=[];
        userIdArr.push(row.id);
        param.userIdArr=userIdArr;
        this.$confirm('确定移除人员 <'+row.name+'> ？', '提示').then(_ => {
            delRoleUser(param).then(({data}) => {
                if (data.status) {
                    this.$message.success(data.msg);
                    this.getAllUserData();
                    this.getRoleUserData();
                } else {
                    this.$message.warning(data.msg);
                }
            }).catch(_ => {})
      }).catch(_ => {})
    }
   
  }
})
</script>
<style lang="scss" scoped>
.role-user-main{
    padding: 5px 15px;
    height: 48%;
    border: solid 1px #dadada;
    .table-main{
        height: calc(100% - 106px);
    }
}
.top-cen-tip{
    padding: 0px 10px;
    background: linear-gradient(-45deg,transparent 20px, #0099ff 0) bottom right,
                linear-gradient(-135deg,transparent 20px,#00548c 0) top right;
    color: white;
    font-size: 14px;
    font-weight: bold;
    min-width: 100px;
}
</style>
<style lang="scss" >
.sys-role-drawer {
  .el-drawer__header {
    padding: 5px 10px;
    background: #f7f7f7;
    margin-bottom: 0px;
  }
}
</style>